import Layout from "../../layout/Layout";
import AdminWalletTable from "./components/table";
import { useEffect, useState } from "react";
import { FaWallet } from "react-icons/fa";
import CardComponent from "../../components/card";
import TableSkeleton from "../../components/skeleton/table";
import CardSkeleton from "../../components/skeleton/card";
import PaginationComponent from "../../components/pagination";
import api from "../../services/api";

const Wallet = () => {
  const [activeTab, setActiveTab] = useState("inbound");
  const [loading, setLoading] = useState({});
  const [balance, setBalance] = useState({});

  const [inboundData, setInboundData] = useState([]);
  const [outboundData, setOutboundData] = useState([]);
  const [mergedData, setMergedData] = useState([]);

  const [pageNos, setPageNos] = useState({
    inbound: 1,
    outbound: 1,
    merge: 1,
  });

  const [totalPagesMap, setTotalPagesMap] = useState({
    inbound: 1,
    outbound: 1,
    merge: 1,
  });

  const setApiLoading = (key, value) => {
    setLoading((prev) => ({ ...prev, [key]: value }));
  };

  const fetchTransactionData = async (type) => {
    const key = type === "merge" ? "inoutbound" : type;
    const currentPage = pageNos[type];

    setApiLoading(type, true);
    try {
      const { data } = await api.get(
        `/admin/platformTransactions?type=${key}&page=${currentPage}`
      );
      const result = data?.data || [];
      setTotalPagesMap((prev) => ({ ...prev, [type]: data?.totalPages || 1 }));

      if (type === "inbound") setInboundData(result);
      else if (type === "outbound") setOutboundData(result);
      else if (type === "merge") setMergedData(result);
    } catch (error) {
      console.error(`Error fetching ${type} transactions`, error);
    } finally {
      setApiLoading(type, false);
    }
  };

  const fetchWalletBalance = async () => {
    if (Object.keys(balance).length) return;
    setApiLoading("balance", true);
    try {
      const { data } = await api.get(
        "/admin/platformBalance"
      );
      setBalance(data?.data);
    } catch (error) {
      console.error("Error fetching wallet balance", error);
    } finally {
      setApiLoading("balance", false);
    }
  };

  useEffect(() => {
    fetchWalletBalance();
  }, []);

  useEffect(() => {
    const shouldFetch =
      (activeTab === "inbound" && inboundData.length === 0) ||
      (activeTab === "outbound" && outboundData.length === 0) ||
      (activeTab === "merge" && mergedData.length === 0);

    if (shouldFetch) {
      fetchTransactionData(activeTab);
    }
  }, [activeTab]);

  useEffect(() => {
    fetchTransactionData(activeTab);
  }, [pageNos[activeTab]]);

  const handlePageChange = (page) => {
    setPageNos((prev) => ({ ...prev, [activeTab]: page }));
  };

  const stats = [
    {
      icon: <FaWallet size={30} color="#52c41a" />,
      number: `${balance?.balance} PKR`,
      label: "Balance",
    },
  ];

  const renderContent = () => {
    if (loading[activeTab]) {
      return <TableSkeleton columns={5} rows={4} />;
    }
    switch (activeTab) {
      case "inbound":
        return <AdminWalletTable data={inboundData} tab={activeTab} />;
      case "outbound":
        return <AdminWalletTable data={outboundData} tab={activeTab} />;
      case "merge":
        return <AdminWalletTable data={mergedData} tab={activeTab} />;
      default:
        return null;
    }
  };

  return (
    <Layout>
      <div className="row text-start">
        <h3 className="h3">Platform Wallet</h3>
      </div>

      {loading["balance"] ? (
        <CardSkeleton loading={loading["balance"]} boxes={3} />
      ) : (
        <CardComponent data={stats} />
      )}

      <div className="mt-4 col-12 mx-auto shadow border rounded px-2 py-2">
        <ul className="nav nav-tabs mb-3">
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "inbound" ? "active" : ""}`}
              onClick={() => setActiveTab("inbound")}
            >
              Commission
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "outbound" ? "active" : ""}`}
              onClick={() => setActiveTab("outbound")}
            >
              Withdraw
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "merge" ? "active" : ""}`}
              onClick={() => setActiveTab("merge")}
            >
              Transaction's History
            </button>
          </li>
        </ul>

        <div className="tab-content">
          <div className="table-responsive">{renderContent()}</div>
        </div>

        <div className="text-end">
          <PaginationComponent
            currentPage={pageNos[activeTab]}
            totalPages={totalPagesMap[activeTab]}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </Layout>
  );
};

export default Wallet;
